// This file is auto-generated during build
export const version = {
  release: 'oak-checkin-site@5e2142a'
};
